// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SelectIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SelectIcon" ref={forwardedRef} {...props}>
      <path d="M16 17h-1v-2h2v1a1 1 0 0 1-1 1" />
      <path d="M17 5V4a1 1 0 0 0-1-1h-1v2z" />
      <path d="M3 16v-1h2v2H4a1 1 0 0 1-1-1" />
      <path d="M4 3h1v2H3V4a1 1 0 0 1 1-1" />
      <path d="M11 3h2v2h-2z" />
      <path d="M7 3h2v2H7z" />
      <path d="M15 7h2v2h-2z" />
      <path d="M15 11h2v2h-2z" />
      <path d="M11 15h2v2h-2z" />
      <path d="M7 15h2v2H7z" />
      <path d="M3 7h2v2H3z" />
      <path d="M3 11h2v2H3z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SelectIcon = /* @__PURE__ */ Object.assign(SelectIconComponent, {
  displayName: 'SelectIcon',
});
